import { useState } from 'react';
import ScreenContainer from '../../components/ScreenContainer';
import Header from '../../components/Header';
import Button from '../../components/Button';
import { typography } from '../../styles/typography';
import colors from '../../styles/colors';
import Footer from '../../components/Footer';
import DropDown from '../../icons/DropDown';
import VideoCam from '../../icons/VideoCam';
import Camera from '../../icons/Camera';
import Check from '../../icons/Check';
import CancelRound from '../../icons/CancelRound';
import Play from '../../icons/Play';


export default function InquirySuccess() {
  const [showTypes, setShowTypes] = useState(false)
  const [types, setTypes] = useState(["A/S", "App related", "Device related", "Other"])
  const [type, setType] = useState()
  const [subject, setSubject] = useState("")
  const [content, setContent] = useState("")
  const allElementsValid = type != null && !!subject && !!content
  const [images, setImages] = useState(null);

  const handleImageChange = (e, type) => {
    const newImgs = Array.from(e.target.files).map((file) => ({ url: URL.createObjectURL(file), type: type }));
    if(newImgs.length + images.length > 5){
      alert("이미지 및 영상은 최대 5개까지 첨부 가능합니다")
      return
    }

    setImages([...images || [], ...newImgs]);
  };

  function handleRemoveImage(i) {
    const newImgs = [...images]
    newImgs.splice(i, 1)
    setImages(newImgs)
  }

  function handleTypeChange(i) {
    setType(i)
    setShowTypes(false)
  }

  return (
    <ScreenContainer style={style.container}>
      <Header />
      <div className={"scrollContainer"} style={style.scrollContainer}>
        <div style={style.title} className='mt-24'>문의 작성 완료</div>
        <div style={style.content} className='mt-16'>문의해 주셔서 감사합니다. 저희 팀에서 내용을 검토한 후, 빠른 시일 내에 확인 후 답변드릴게요.<br/><br/>Team Eyeary.</div>
      </div>
      <div className="button-wrapper" style={{ paddingLeft: 16, paddingRight: 16 }}>
        <Button
          text="멤버십 홈으로 가기"
          type="submit"
          className={ "primary-on-button primary-button-text"}
          onClick={(e) => { }}
        />
        <Button
          text="앱으로 가기"
          type="submit"
          className={ "primary-off-button primary-button-text mt-8"}
          style={{background: 'transparent'}}
          onClick={(e) => { }}
        />
      </div>
    </ScreenContainer>

  );
}

const style = {
  container: {
    maxHeight: '100vh',
    overflow: 'hidden',
  },
  scrollContainer: {
    alignItems: 'flex-start',
    overflowY: 'scroll',
    flex: 1
  },
  title: {
    ...typography.title.m_24_medium,
    color: colors.white
  },
  content: {
    color: colors.mono300,
    height: '100%',
    width: '100%'
  },
}